/* ============================================================
   Craft Com — liste des logos « Ils nous font confiance »
   Cette liste remplace celle de app.js (const CLIENTS).
   Pour ajouter/retirer un client : modifier ce fichier uniquement.
   ============================================================ */
(function () {
  if (typeof CLIENTS === 'undefined' || typeof buildClients !== 'function') return;
  var LIST = [
    {name:'La Perle',        sub:'Parfumerie',          c:'#d9b86b', img:'cc-logo-laperle.jpg'},
    {name:'NM Wash',         sub:'Lavage auto',         c:'#1a3fd1', img:'cc-logo-nmwash.jpg'},
    {name:'Footify',         sub:'Maillots foot',       c:'#7bd13a', img:'cc-logo-footify.png'},
    {name:'Waksi',           sub:'Siwak',               c:'#1f4a32', img:'cc-logo-waksi.jpg'},
    {name:'G & K Motors',    sub:'Auto / Lavage',       c:'#2f8ae6', img:'cc-logo-gmotors.jpg'},
    {name:'My Shop Digital', sub:'Gadgets tech',        c:'#ee7aa8', img:'cc-logo-myshopdigital.jpg'},
    {name:'Kiosk',           sub:'Épicerie',            c:'#27c2ff', img:'cc-logo-kiosk.jpg'},
    {name:'RMZ Rent Cars',   sub:'Location de véhicules', c:'#1fc7f5', img:'cc-logo-rmz.jpg'},
    {name:'Atelier Vert',    sub:'Espaces verts',       c:'#34d399', img:'cc-logo-ateliervert.jpg'},
    {name:'MLN Pods',        sub:'Produits électroniques', c:'#f2c230', img:'cc-logo-mlnpods.jpg'},
    {name:'Booster',         sub:'Streameur',           c:'#e23b3b', img:'cc-logo-booster.jpg'},
    {name:'Nord Chauffage',  sub:'Chauffage & plomberie', c:'#e01b1b', img:'cc-logo-nordchauffage.jpg'},
    {name:'El Riadh',        sub:'Restaurant',          c:'#7b2fd1', img:'cc-logo-elriadh.png'},
    {name:'DB Fragrance',    sub:'Parfumerie',          c:'#d4a53c', img:'cc-logo-dbfragrance.jpg'},
    {name:'King Burger',     sub:'Fast-food',           c:'#ff4d2e', img:'cc-logo-kingburger.jpg'},
    {name:'HM Elec',         sub:'Électricité',         c:'#f5d020', img:'cc-logo-hmelec.jpg'},
    {name:'KFB',             sub:'Fast-food',           c:'#e8852f', img:'cc-logo-kfb.jpg'},
    {name:'YM Location',     sub:'Location auto',       c:'#cbb89a', img:'cc-logo-ymlocation.jpg'},
    {name:'MCDF',            sub:'Sneakers',            c:'#c0392b', img:'cc-logo-mcdf.jpg'},
    {name:'SOS Crevaison',   sub:'Dépannage',           c:'#e23b3b', img:'cc-logo-soscrevaison.jpg'},
    {name:'OBAK Burger',     sub:'Fast-food',           c:'#ffcf00', img:'cc-logo-bakburger.png'},
    {name:'Crispy Corner',   sub:'Fast-food',           c:'#ff3fae', img:'cc-logo-crispycorner.png'},
    {name:'SD Dépannage',    sub:'Dépannage',           c:'#e82f2f', img:'cc-logo-sddepannage.png'}
  ];
  CLIENTS.length = 0;
  Array.prototype.push.apply(CLIENTS, LIST);
  buildClients();
})();
